<template>
    <div class="md:grid md:grid-cols-3 md:gap-6">
        <jet-section-title>
            <template #title><slot name="title"></slot></template>
            <template #description><slot name="description"></slot></template>
        </jet-section-title>

        <div class="mt-5 md:mt-0 md:col-span-2">
            <div class="overflow-hidden shadow sm:rounded-lg">

                <transition
                    enter-active-class="ease-out duration-300" enter-from-class="h-0" enter-to-class="h-1"
                    leave-active-class="ease-in duration-200" leave-from-class="h-1" leave-to-class="h-0">
                    <working-bar v-if="working"></working-bar>
                </transition>

                <div class="px-4 py-5 sm:p-6 bg-white">
                    <slot name="content"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { defineComponent } from 'vue'
    import JetSectionTitle from './SectionTitle.vue'
    import WorkingBar from "../Components/WorkingBar";

    export default defineComponent({
        components: {
            WorkingBar,
            JetSectionTitle,
        },
        props: ['working'],
    })
</script>
